import { render, staticRenderFns } from "./OptionArticleDataTable.vue?vue&type=template&id=774bbed3"
import script from "./OptionArticleDataTable.vue?vue&type=script&lang=ts"
export * from "./OptionArticleDataTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports